import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { approveAdminProfileEdit } from "../Apis/AdminApis";
import { viewAllAdmins } from "../Apis/SuperadminApis";
import { useNavigate } from "react-router-dom";
import PopupMessage from "../PopupMessage/PopupMessage";
import {FiChevronLeft,FiChevronRight,FiSearch,FiFilter} from "react-icons/fi";
import "./AdminProfileRequests.css";
import pavamanLogo from "../images/drone.png";

const AdminProfileRequests = () => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [processingId, setProcessingId] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [stats, setStats] = useState({
    pending: 0,
    approved: 0,
    total: 0
  });
    const [isPaginationLoading, setIsPaginationLoading] = useState(false);
const [requestFilter, setRequestFilter] = useState("all");
const [showMobileFilters, setShowMobileFilters] = useState(false);

useEffect(() => { 
  let role = "";
  try {
    const sessionData = JSON.parse(sessionStorage.getItem("session_data") || "{}");
    role = sessionData.role || "";
  } catch (e) {
    console.log("Error parsing session_data:", e);
  }

  if (!role) {
    role = sessionStorage.getItem("role") || 
           localStorage.getItem("role") || 
           sessionStorage.getItem("adminRole") || 
           localStorage.getItem("adminRole") || "";
  }
  
  if (role === "1") role = "admin";
  if (role === "2") role = "superadmin";
  
  console.log("✅ Role found for Profile Requests:", role); // Debug
  
  if (role !== "superadmin") { 
    setPopupMessage("You are not authorized to view this page. Role: " + role); 
    setPopupType("error"); 
    setPopupOpen(true); 
    setTimeout(() => navigate("/dashboard"), 2000); 
    return; 
  } 
   
  fetchAdminRequests(); 
}, []);

const fetchAdminRequests = async () => {
  try {
    setLoading(true);

    const response = await viewAllAdmins({});

    console.log("📦 API Response:", response);

    if (response?.error) {
      setPopupMessage(response.error);
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    const admins = Array.isArray(response?.data)
      ? response.data
      : [];

    console.log("👥 All Admins:", admins);
    const profileRequests = admins.filter(
      (admin) =>
        Number(admin.profile_edit_status) === 1 ||
        Number(admin.profile_edit_status) === 2
    );

    console.log("✅ Profile Edit Requests:", profileRequests);
    setRequests(profileRequests);
    const pending = profileRequests.filter(
      (admin) => Number(admin.profile_edit_status) === 1
    ).length;

    const approved = profileRequests.filter(
      (admin) => Number(admin.profile_edit_status) === 2
    ).length;

    setStats({
      pending,
      approved,
      total: profileRequests.length,
    });

    setCurrentPage(1);

  } catch (err) {
    console.error("❌ Error:", err);

    setPopupMessage("Failed to fetch admin requests");
    setPopupType("error");
    setPopupOpen(true);

  } finally {
    setLoading(false);
  }
};

const openApproveModal = (admin) => {
  setSelectedAdmin(admin);
  setShowApproveModal(true);
};

const closeApproveModal = () => {
  if (processingId) return;

  setShowApproveModal(false);
  setSelectedAdmin(null);
};

const handleApprove = async (adminId) => {
  setProcessingId(adminId);

  try {
    const response = await approveAdminProfileEdit({
      admin_id: adminId,
      action: "approve"
    });

    if (response?.error) {
      setPopupMessage(response.error);
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    setShowApproveModal(false);
    setSelectedAdmin(null);

    setPopupMessage(
      response.message ||
      "Profile edit request approved successfully"
    );

    setPopupType("success");
    setPopupOpen(true);
    fetchAdminRequests();

  } catch (err) {
    console.error("❌ Error:", err);

    setPopupMessage("Failed to approve request");
    setPopupType("error");
    setPopupOpen(true);

  } finally {
    setProcessingId(null);
  }
};

  const handleWithdraw = async (adminId) => {
    setProcessingId(adminId);
    try {
      const response = await approveAdminProfileEdit({
        admin_id: adminId,
        action: "withdraw"
      });

      if (response?.error) {
        setPopupMessage(response.error);
        setPopupType("error");
        setPopupOpen(true);
        return;
      }

      setPopupMessage(response.message || "Profile edit approval withdrawn successfully");
      setPopupType("success");
      setPopupOpen(true);
      fetchAdminRequests();
    } catch (err) {
      console.error("❌ Error:", err);
      setPopupMessage("Failed to withdraw approval");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setProcessingId(null);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setIsPaginationLoading(true);
      setCurrentPage(newPage);
      setTimeout(() => setIsPaginationLoading(false), 300);
    }
  };

const getStatusBadge = (status) => {
  switch (Number(status)) {
    case 1:
      return (
        <span className="apr-status-badge apr-status-pending">
          Pending
        </span>
      );

    case 2:
      return (
        <span className="apr-status-badge apr-status-approved">
          Approved
        </span>
      );

    default:
      return (
        <span className="apr-status-badge apr-status-none">
          No Request
        </span>
      );
  }
};

const getStatusActions = (request) => {
  const status = Number(request.profile_edit_status);

  if (status === 1) {
    return (
      <button
  className="apr-action-btn apr-approve-btn"
  onClick={() => openApproveModal(request)}
  disabled={processingId === request.id}
>
        {processingId === request.id ? (
          <span className="apr-spinner-small"></span>
        ) : (
          "Approve"
        )}
      </button>
    );
  }

  if (status === 2) {
    return (
      <button
        className="apr-action-btn apr-withdraw-btn"
        onClick={() => handleWithdraw(request.id)}
        disabled={processingId === request.id}
      >
        {processingId === request.id ? (
          <span className="apr-spinner-small"></span>
        ) : (
          "Withdraw"
        )}
      </button>
    );
  }

  return <span className="apr-no-action">—</span>;
};

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch {
      return dateStr;
    }
  };

const requestStatusCounts = {
  all: requests.length,

  pending: requests.filter(
    (request) => Number(request.profile_edit_status) === 1
  ).length,

  approved: requests.filter(
    (request) => Number(request.profile_edit_status) === 2
  ).length,
};

const filteredRequests = requests.filter((request) => {
  const searchLower = searchTerm.toLowerCase();

  const matchesSearch =
    (request.name &&
      request.name.toLowerCase().includes(searchLower)) ||
    (request.email &&
      request.email.toLowerCase().includes(searchLower)) ||
    (request.company_name &&
      request.company_name.toLowerCase().includes(searchLower));

  const status = Number(request.profile_edit_status);

  const matchesFilter =
    requestFilter === "all" ||
    (requestFilter === "pending" && status === 1) ||
    (requestFilter === "approved" && status === 2);

  return matchesSearch && matchesFilter;
});

// Pagination
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentRequests = filteredRequests.slice(
  indexOfFirstItem,
  indexOfLastItem
);

const totalPages = Math.ceil(
  filteredRequests.length / itemsPerPage
);
  return (
    <div className="dashboard-wrapper">
      <Sidebar />

      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      {showApproveModal && selectedAdmin && (
  <div
    className="tr-modal-overlay"
    onClick={closeApproveModal}
  >
    <div
      className="tr-modal-content tr-modal-small"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="tr-modal-header">
        <h2>Approve Profile Edit</h2>

        <button
          className="tr-modal-close"
          onClick={closeApproveModal}
          disabled={processingId === selectedAdmin.id}
        >
          ✕
        </button>
      </div>

      <div className="tr-modal-body">
        <div className="tr-confirm-container">

          <div className="tr-confirm-icon tr-confirm-approve">
            ✓
          </div>

          <p className="tr-confirm-text">
            Are you sure you want to approve the profile edit request
            for <strong>{selectedAdmin.name}</strong>?
          </p>

          <p className="tr-confirm-subtext">
            The admin will be allowed to update their profile information.
          </p>

          <div className="tr-confirm-buttons">

            <button
              className="tr-confirm-cancel"
              onClick={closeApproveModal}
              disabled={processingId === selectedAdmin.id}
            >
              Cancel
            </button>

            <button
              className="tr-confirm-approve-btn"
              onClick={() => handleApprove(selectedAdmin.id)}
              disabled={processingId === selectedAdmin.id}
            >
              {processingId === selectedAdmin.id ? (
                <>
                  <span className="tr-spinner-small"></span>
                  Processing...
                </>
              ) : (
                "Yes, Approve"
              )}
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
)}

      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Admin Profile Edit Requests</h1>
            <p className="dashboard-subtitle">
              Manage profile edit requests from admins under your supervision
            </p>
          </div>
        </div>

<div className="sa-filter-section">
  <div className="sa-search-wrapper">
    <FiSearch className="sa-search-icon" />
    <input
      type="text"
      placeholder="Search by admin name, email, or company..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      className="sa-search-input"
    />

    <button
      className="sa-mobile-filter-toggle"
      onClick={() => setShowMobileFilters(!showMobileFilters)}
    >
      <FiFilter />
      Filters
    </button>

  </div>

  {/* Filters */}
  <div
    className={`sa-filters ${
      showMobileFilters ? "mobile-open" : ""
    }`}
  >

    {/* All Requests */}
    <button
      className={`sa-filter-btn ${
        requestFilter === "all" ? "active" : ""
      }`}
      onClick={() => {
        setRequestFilter("all");
        setCurrentPage(1);
        setShowMobileFilters(false);
      }}
    >
      📋 All Requests ({requestStatusCounts.all})
    </button>

    {/* Pending */}
    <button
      className={`sa-filter-btn ${
        requestFilter === "pending" ? "active" : ""
      }`}
      onClick={() => {
        setRequestFilter("pending");
        setCurrentPage(1);
        setShowMobileFilters(false);
      }}
    >
      ⏳ Pending ({requestStatusCounts.pending})
    </button>

    {/* Approved */}
    <button
      className={`sa-filter-btn ${
        requestFilter === "approved" ? "active" : ""
      }`}
      onClick={() => {
        setRequestFilter("approved");
        setCurrentPage(1);
        setShowMobileFilters(false);
      }}
    >
      ✓ Approved ({requestStatusCounts.approved})
    </button>

  </div>

</div>

        {/* Table */}
        {loading ? (
          <div className="va-loading-container">
           <img src={pavamanLogo} alt="Loading" className="va-spinning-logo" />
            <p className="va-loading-text">Loading requests...</p>
          </div>
        ) : (
          <>
            <div className="tr-table-container">
              <table className="tr-table">
                <thead className="tr-head">
                  <tr>
                    <th>Admin</th>
                    <th>Email</th>
                    <th>Company</th>
                    <th>Requested On</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRequests.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="apr-empty-table">
                        <div className="apr-empty-state">
                          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                          </svg>
                          <p>No profile edit requests found</p>
                          <span>All requests will appear here when admins request profile edits</span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    currentRequests.map((request) => (
                      <tr key={request.id}>
                        <td>
                          <div className="apr-admin-cell">
                            <div className="apr-admin-avatar">
                              {request.name ? request.name.charAt(0).toUpperCase() : "A"}
                            </div>
                            <span className="apr-admin-name">{request.name || "Unknown"}</span>
                          </div>
                        </td>
                        <td className="apr-email-cell">{request.email || "N/A"}</td>
                        <td>{request.name || "N/A"}</td>
                        <td>
  {formatDate(
    request.profile_edit_requested_on ||
    request.updated_on ||
    request.created_on
  )}
</td>
                        <td>{getStatusBadge(request.profile_edit_status)}</td>
                        <td>{getStatusActions(request)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
             {totalPages > 1 && (
                        <div className="pv-pilot-pagination-wrapper">
                          <div className="pv-pilot-pagination-controls">
                            <button
                              className="pv-pilot-pagination-btn"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1 || isPaginationLoading}
                            >
                              <FiChevronLeft size={16} />
                              Previous
                            </button>
                            
                            <div className="pv-pilot-page-numbers">
                              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                let pageNumber;
                                if (totalPages <= 5) {
                                  pageNumber = i + 1;
                                } else if (currentPage <= 3) {
                                  pageNumber = i + 1;
                                } else if (currentPage >= totalPages - 2) {
                                  pageNumber = totalPages - 4 + i;
                                } else {
                                  pageNumber = currentPage - 2 + i;
                                }
                                
                                return (
                                  <button
                                    key={pageNumber}
                                    className={`pv-pilot-page-btn ${currentPage === pageNumber ? 'pv-pilot-active' : ''}`}
                                    onClick={() => handlePageChange(pageNumber)}
                                    disabled={isPaginationLoading}
                                  >
                                    {pageNumber}
                                  </button>
                                );
                              })}
                            </div>
                            
                            <button
                              className="pv-pilot-pagination-btn"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages || isPaginationLoading}
                            >
                              Next
                              <FiChevronRight size={16} />
                            </button>
                          </div>
                        </div>
                      )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdminProfileRequests;